var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"anthro-result-table"},[_c('a-table',{attrs:{"scroll":{ y: 350 },"columns":_vm.columns,"data-source":_vm.tableData,"pagination":false,"size":"small"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }